<template>
  <div class="content mt-n12">
    <div class="ma-0 pa-0" v-if="dropFiles">
      <div class="head sticky mt-n10">
        <div class="tabs-group">
          <draggable :list="$data.tabs" v-bind="dragOptions" :style="tabsWidth">
            <transition-group class="tabs" name="list-complete">
              <template v-for="tab in $data.tabs">
                <div
                  :class="[active(tab.id), 'tab']"
                  :key="tab.id"
                  @mousedown="changeTab(tab.id)"
                >
                  <v-row class="text ma-0 pa-0" justify="start">
                    <v-checkbox class="mt-1 ml-2"></v-checkbox>
                    <p
                      class="pt-3"
                      v-if="tab.checked"
                      style="font-size: 16px; opacity: 0.8; font-weight: 800"
                    >
                      {{ tab.name }}
                    </p>
                  </v-row>

                  <div
                    class="close-button"
                    @mousedown="beforeCloseTab($event)"
                    @click="closeTab(tab.id)"
                  ></div>
                </div>
              </template>
            </transition-group>
          </draggable>
          <div key="add-button" class="add-button" @click="addTab"></div>
        </div>
      </div>

      <div class="content mt-8">
        <template v-for="tab in $data.tabs">
          <div :class="[active(tab.id), 'tab-content']" :key="tab.id">
            <div>
              <addFile
                :compoID="tab.id.toString()"
                :batch="batch"
                :batchFile="tab.file"
              ></addFile>
            </div>
            <!-- <div v-if="tab.id === 1">
              <addFile compoID="1"></addFile>
            </div>
            <div v-if="tab.id === 2">
              <addFile compoID="2"></addFile>
            </div> -->

            <!-- <img class="image" :src="'https://picsum.photos/800/800?random=' + tab.id" /> -->
          </div>
        </template>
      </div>
    </div>
    <div class="ma-0 pa-0 drop-zone" v-if="!dropFiles">
      <v-icon
        @click="toggleSidebar()"
        style="position: absolute; top: 10px; left: 20px; z-index: 10000"
      >
        mdi-dots-vertical
      </v-icon>
      <div class="drop-zone__prompt">
        <md-icon
          v-if="augmentableTheme"
          class="drop-zone__prompt md-size-5x"
          md-src="/static/assets/svg/white/Drag and Drop.svg"
        />
        <md-icon
          v-if="!augmentableTheme"
          class="drop-zone__prompt md-size-5x"
          md-src="/static/assets/svg/black/Drag and Drop.svg"
        />
      </div>
      <input type="file" name="ARfile" id="rr" class="drop-zone__input" />
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import addFile from "./addFile.vue";

import { mapState } from "vuex";

//import glbFiles from "./GlbFiles.vue";
export default {
  components: {
    draggable,
    addFile,
    //glbFiles,
  },
  data() {
    return {
      dropFiles: false,
      files: "",
      batch: true,
      currentTabId: 1,
      nextTabId: 4,
      tabs1: [
        {
          id: 1,
          name: "File name...",
          checked: true,
        },
        {
          id: 2,
          name: "File name...",
          checked: false,
        },
        {
          id: 3,
          name: "File name",
          checked: false,
        },
      ],
      tabs: [],
    };
  },
  computed: {
    active() {
      return (id) => id === this.$data.currentTabId && "-active";
    },
    dragOptions() {
      return {
        animation: 250,
        disabled: false,
        ghostClass: "-dragging",
      };
    },
    tabsWidth() {
      return {
        maxWidth: this.$data.tabs.length * 190 + "px",
        width: "100%",
        minWidth: "0px",
        transition: "max-width 0.2s",
      };
    },
    ...mapState(["augmentableTheme"]),
  },
  mounted() {
    document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
      const dropZoneElement = inputElement.closest(".drop-zone");
      dropZoneElement.addEventListener("dragover", (e) => {
        e.preventDefault();
        //dropZoneElement.classList.add("drop-zone--over");
      });
      ["dragleave", "dragend"].forEach((type) => {
        dropZoneElement.addEventListener(type, (e) => {
          console.log(e);
          //dropZoneElement.classList.remove("drop-zone--over");
        });
      });
      dropZoneElement.addEventListener("drop", (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
          this.dropFiles = true;
          inputElement.files = e.dataTransfer.files;
          this.files = e.dataTransfer.files;
          console.log(this.files);
          console.log(this.files.length);
          // var i;
          //var len;

          this.tabs = [];
          const files = [...this.files];
          for (let [index, val] of files.entries()) {
            // your code goes here

            var item = {
              id: "",
              name: "",
              checked: "",
              file: "",
            };
            item.id = index + 1;
            item.name = "File name";
            if (item.id === 1) {
              item.checked = true;
            } else {
              item.checked = false;
            }

            item.file = val;
            this.tabs.push(item);
          }
          // for (i = 0, len = this.files.length; i < len; i++) {
          //   //console.log(i + 1);

          //   item.id = i + 1;
          //   console.log(item.id);
          //   item.name = "File name" + i;
          //   item.checked = false;
          //   this.tabs.push(item);
          // }
          console.log(this.tabs);

          //this.updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
        }

        //dropZoneElement.classList.remove("drop-zone--over");
      });
    });
  },
  methods: {
    changeTab(id) {
      this.$data.currentTabId = id;

      var index = this.tabs.findIndex((x) => x.id === id);
      var i;
      var len;
      for (i = 0, len = this.tabs.length; i < len; i++) {
        if (index === i) {
          this.tabs[i].checked = true;
        } else {
          this.tabs[i].checked = false;
        }
      }
    },
    beforeCloseTab(e) {
      e.stopPropagation();
    },
    addTab() {
      this.$data.tabs.push({
        id: this.$data.nextTabId,
        name: "new tab",
      });
      this.$data.currentTabId = this.$data.nextTabId;
      this.$data.nextTabId++;
    },
    closeTab(id) {
      this.$data.tabs.forEach((tab, index) => {
        tab.id === id &&
          this.$data.tabs.splice(index, 1) &&
          this.$data.currentTabId === id &&
          (this.$data.currentTabId = this.$data.tabs[index]
            ? this.$data.tabs[index].id
            : this.$data.tabs[index - 1].id);
      });
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      console.log(this.$sidebar.showSidebar);
    },
  },
};
</script>

<style lang="scss" scoped>
$white: transparent;
$gray-dark: #dee1e6;
$gray-light: #a1ceff;

// body {
//   //padding: 20px;
//   width:100%;
//   font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif;
//   display: flex;
//   align-items: center;
//   height: 100vh;
//   box-sizing: border-box;
//   background: linear-gradient(135deg, rgb(250,250,255) 0%, rgb(240,240,246) 50%, rgb(230,230,237) 100%);
// }

// .window {
//   width: 100%;
//   max-width: 800px;
//   max-height: 500px;
//   height: 100%;
//   border-radius: 8px;
//   overflow: hidden;
//   background-color: #fff;
//   box-shadow: 4px 8px 20px rgba(0, 0, 0, 0.2);
//   display: flex;
//   flex-direction: column;
//   margin: 20px auto;

//   > .content {
//     min-height: 0;
//     height: 100%;
//   }
// }

.head {
  background-color: transparent;
  display: flex;
  overflow: hidden;
  height: 7vh;
  // .buttons {
  //   display: flex;
  //   align-items: center;
  //   padding: 0 4px 0 12px;

  //   > .button {
  //     width: 12px;
  //     height: 12px;
  //     border-radius: 100%;

  //     &:not(:last-child) {
  //       margin-right: 6px;
  //     }

  //     &.-red {
  //       background-color: #fb5a59;
  //     }

  //     &.-yellow {
  //       background-color: #ffc139;
  //     }

  //     &.-green {
  //       background-color: #60d045;
  //     }
  //   }
  // }
}

// .menu {
//   min-height: 36px;
//   display: flex;
//   align-items: center;
//   border-bottom: 1px solid $gray-dark;

//   > .buttons {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     padding: 0 14px;

//     > .arrows {
//       display: flex;
//       justify-content: space-between;
//       width: 44px;

//       > .arrow {
//         width: 14px;
//         height: 2px;
//         background-color: #ccc;
//         border-radius: 100px;
//         position: relative;

//         &::before,
//         &::after {
//           content: "";
//           display: block;
//           background-color: #ccc;
//           position: absolute;
//           width: 71%;
//           height: 100%;
//           border-radius: 100px;
//           transform-origin: center left;
//         }

//         &::before {
//           transform: rotate(45deg);
//         }

//         &::after {
//           transform: rotate(-45deg);
//         }

//         &.-forward {
//           transform: rotate(180deg);
//         }
//       }
//     }
//   }

//   > .search {
//     box-sizing: border-box;
//     border-radius: 100px;
//     border: 0;
//     background-color: #f1f1f1;
//     height: 26px;
//     outline: 0;
//     flex: 1;
//     margin-right: 20px;
//     padding: 0 12px;
//     font-size: 12px;
//     border: 2px solid transparent;

//     &:focus {
//       border: 2px solid #6dbce7;
//     }
//   }
// }

.tabs-group {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 8px;
  min-width: 0px;

  > .add-button {
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    padding: 8px;
    margin: 0 4px 2px;
    border-radius: 100%;
    transition: background-color 0.5s;

    &:hover {
      background-color: #ccc;
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 2px;
      height: 14px;
      background-color: #666;
    }

    &::before {
      transform: rotate(90deg);
    }
  }
}

.tabs {
  display: inline-flex;
  align-items: flex-end;
  box-sizing: border-box;
  padding: 0 8px;
  line-height: 1;
  position: relative;
  z-index: 1;
  user-select: none;
  width: 100%;
}

.tab {
  position: relative;
  background-color: rgb(212, 212, 212);
  padding: 6px 10px;
  border-radius: 4px 4px 0 0;
  font-size: 12px;
  display: block;
  max-width: 65px;
  //padding-top: 3px;
  // border-radius:1rem;
  transition: background-color 0.2s;
  cursor: default;
  position: relative;
  margin-right: 6px;
  white-space: nowrap;
  flex: 1;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-box-shadow: 0 0 10px grey;
  -moz-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;

  &:hover {
    background-color: $gray-light;

    &::before {
      background-color: $gray-light;
      right: 0;
    }
  }

  &.-active {
    background-color: $white;
    max-width: 200px;

    &::before {
      background-color: $white;
      right: 0;
    }
  }

  &.-dragging {
    opacity: 0;
  }

  &::after {
    content: "";
    display: block;
    // height: 20px;
    // width: 1px;
    height: 0px;
    width: 0px;
    background-color: #888;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    z-index: -1;
  }

  &::before {
    content: "";
    display: block;
    height: 20px;
    width: 20px;
    position: absolute;
    border-radius: 100%;
    right: 1px;
    top: 0;
    background-color: $gray-dark;
    transition: background-color 0.2s;
  }

  > .close-button {
    width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(45deg);
    border-radius: 100%;
    padding: 0px;
    position: absolute;
    cursor: pointer;
    top: 5px;
    right: 6px;

    &:hover {
      background-color: #ddd;
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 2px;
      height: 12px;
      background-color: #666;
    }

    &::before {
      transform: rotate(90deg);
    }
  }
}

.tab-content {
  display: none;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;

  &.-active {
    display: block;
  }

  > .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 10000 !important;
  top: 0;
}

.drop-zone {
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh;
  cursor: pointer;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  min-height: 100vh;
}

.drop-zone__thumb::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;

  font-size: 14px;
  text-align: center;
}
.drop-zone__prompt {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
</style>
